'use strict';

module.exports = {
  SPLIT_KILLED: 'killed',
  NO_CONDITION_MATCH: 'no rule matched',
  SPLIT_NOT_FOUND: 'rules not found',
  EXCEPTION: 'exception',
  SPLIT_ARCHIVED: 'archived',
  NOT_IN_SPLIT: 'not in split'
};


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/utils/labels/index.js
// module id = 397
// module chunks = 0